import { EyeOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import type { TableProps } from 'antd';
import { Button, Col, ConfigProvider, DatePicker, Drawer, Flex, Input, Layout, Row, Select, Skeleton, Table, Tabs, Tooltip, notification } from "antd";
import { SorterResult } from "antd/es/table/interface";
import dayjs from "dayjs";
import { useEffect, useState, useRef } from "react";
import { ColumnDropdown } from "../../../components/common/ColumnDropdown";
import { LoaderSpinner } from "../../../components/common/Loader";
import { getCobDenailInvoices, getCobDenialInvoiceFilters } from "../../../service/httpsCalls";
import CreateCOBDenialInvoice from "./createCOBDenialInvoice";
import COBDenialInvoiceDetails, { ChildRef } from "./cobDenialInvoicesDetails";
import CobDenialImportTripLegs from "./cobDenialImportTripLegs";
import { createTableConfig } from "../tableConfig";
const { Option } = Select;
const { RangePicker } = DatePicker;

const { TabPane } = Tabs;
interface ClientData {
    id: number,
    name: string
}

interface FilterData extends ClientData {
    clientId: number
}

interface StatusData extends FilterData {
    invoiceTypeId: number
}

interface CheckedProps {
    item: string;
    checked: boolean;
}

type NotificationType = 'success' | 'info' | 'warning' | 'error';
export default function CobDenailInvoices() {
    const childRef = useRef<ChildRef>(null);
    const [api, contextHolder] = notification.useNotification();
    const [clientList, setClientList] = useState<FilterData[]>([]);
    const [invoiceTypes, setInvoiceTypes] = useState<FilterData[]>([]);
    const [statusList, setStatusList] = useState<StatusData[]>([]);
    const [pdrCaseList, setPdrCaseList] = useState<FilterData[]>([]);
    const [invoiceTypesLookup, setInvoiceTypesLookup] = useState<FilterData[]>([]);
    const [statusListLookup, setStatusListLookup] = useState<StatusData[]>([]);
    const [payerListLookup, setPayerListLookup] = useState<FilterData[]>([]);
    const [payerList, setPayerList] = useState<FilterData[]>([]);
    const [tableColumns, setTableColumns] = useState([]);
    const [invoiceNumber, setInvoiceNumber] = useState<string | null>();
    const [client, setClient] = useState<any | null>(null);
    const [startDate, setStartDate] = useState<string | any>('');
    const [endDate, setEndDate] = useState<string | any>('');
    const [status, setStatus] = useState<any | null>(null);
    const [invoiceType, setInvoiceType] = useState<any | null>(null);
    const [payer, setPayer] = useState<any | null>(null);
    const [showModal, setModal] = useState<boolean>(false);
    const [modalData, setModalData] = useState<any>({
        edit: false,
        data: null,
    })
    const [selectedInvoice, setSelectedInvoice] = useState<any>(null);
    const [invoiceList, setInvoiceList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pageSize, setPageSize] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [sortedInfo, setSortedInfo] = useState<SorterResult<any>>({});
    const [menuVisible, setMenuVisible] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [userAccess, setUserAccess] = useState({
        canAdd: false
    })
    const [filterLoader, setFilterLoader] = useState(false);
    const [isChecked, setChecked] = useState<CheckedProps[]>([]);

    const [currentTab, setCurrentTab] = useState("invoiceInfoTab");
    const [showTripLegTab, setShowTripLegTab] = useState(true);

    // drawer settings
    const screenWidth = window.innerWidth;
    const drawerScreenWidth = screenWidth * 0.7;
    const defaultWidth = 1000;
    const [drawerConfig, setDrawerConfig] = useState({
        title: 'Invoice',
        width: Math.max(drawerScreenWidth, defaultWidth)
    })

    const openNotificationWithIcon = (type: NotificationType, message: string, description: string) => {
        api[type]({
            message: message,
            description: description
        });
    };

    const [position, setPosition] = useState({
        x: 0,
        y: 0
    });



    function getFilterData() {
        setFilterLoader(true);
        getCobDenialInvoiceFilters((res: any) => {
            setFilterLoader(false);
            if (res.hasError) {
                openNotificationWithIcon("error", "Something went wrong!!!", "");
                return;
            }
            if (res) {
                setClientList(res.clientList);
                setClient('10');
                setInvoiceTypes(res.invoiceTypeList.filter((x: any) => x.clientId == 10));
                setPayerList(res.payerList.filter((x: any) => x.clientId == 10))
                setInvoiceTypesLookup(res.invoiceTypeList);
                setPdrCaseList(res.pdrCaseList)
                setStatusListLookup(res.invoiceStatusList);
                setPayerListLookup(res.payerList);
                setUserAccess({
                    ...userAccess,
                    canAdd: res.canAdd
                })
            }
        })
    }

    function resetFilters() {
        setInvoiceType(null);
        setStatus(null);
        clientSelected('10')
        setStartDate('');
        setPayer(null)
        setEndDate('');
        setInvoiceNumber(null);
    }

    function getInvoiceList() {
        setLoading(true);
        setInvoiceList([]);
        getCobDenailInvoices({
            "pageIndex": currentPage,
            "pageSize": pageSize,
            "sortField": sortedInfo.order ? sortedInfo.field : null,
            "sortDescending": sortedInfo.order == 'descend',
            "clientId": client,
            "searchByInvoiceDate": true,
            "fromInvoiceDate": startDate && startDate != '' ? startDate : null,
            "toInvoiceDate": endDate && endDate != '' ? endDate : null,
            "invoiceNumber": invoiceNumber ?? null,
            "invoiceTypeId": invoiceType ?? null,
            "payerId": payer ?? null,
            "invoiceStatusId": status
        }, (res: any) => {
            if (res !== 'error') {
                !showTable && setShowTable(true);

                if (res.columnConfigs && !tableColumns.length) {
                    let columns = createTableConfig(res.columnConfigs);

                    columns = [...columns,
                    {
                        title: 'View',
                        dataIndex: 'invoiceNumber',
                        hidden: false,
                        fixed: false,
                        sorter: false,
                        filter: false,
                        width: 100,
                        render: (text: any, record: any) => {
                            return (
                                <Button
                                    onClick={() => {
                                        setModal(true);
                                        setModalData({
                                            edit: true,
                                            data: record
                                        });
                                    }}
                                    style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', color: 'rgba(0, 0, 0, 0.88)' }}
                                    type="primary"
                                    icon={<EyeOutlined />}
                                />
                            );
                        }
                    }
                    ]
                    setTableColumns(columns)
                }

                res.columnConfigs.map((entry: any) => ({ item: entry.title, checked: !entry.hidden }))
                setInvoiceList(res.items);
                setLoading(false)
                setTotalPages(Math.ceil(res.totalRecords / (pageSize / pageSize)));
            } else {
                setInvoiceList([]);
                setLoading(false)
                setTotalPages(1);
            }

        })
    }
    function search() {
        if (!client) {
            openNotificationWithIcon("warning", "Please Select a Client", "");
            return;
        }
        if (pageSize == 0) {
            setPageSize(10);
        } else {
            currentPage == 1 ? getInvoiceList() : setCurrentPage(1);
        }
    }

    const [tableScrollY, setTableScrollY] = useState<number>();

    useEffect(() => {
        getFilterData();
        setPageSize(10);
        document.title = "Cob Denials / Invoices";

        const compute = () => {
            const height = window.innerHeight - 520;
            setTableScrollY(height > 0 ? height : undefined);
        };

        compute();
        window.addEventListener("resize", compute);
        return () => window.removeEventListener("resize", compute);
    }, []);

    useEffect(() => {
        if (pageSize != 0)
            getInvoiceList();
    }, [currentPage, pageSize, sortedInfo]);

    useEffect(() => {
        setStatus(null)
        if (client && invoiceType) {
            setStatusList(statusListLookup.filter(x => x.clientId == client && x.invoiceTypeId == invoiceType));
        }
    }, [client, invoiceType])

    const handleTableChange: TableProps<any>['onChange'] = (pagination, filters, sorter, extra) => {
        setCurrentPage(pagination.current ?? 1);
        setPageSize(pagination.pageSize ?? 10);
        setTotalPages(pagination.total ?? 100);
        setSortedInfo(sorter as SorterResult<any>);
    };

    function clientSelected(e: any) {
        setClient(e);
        setInvoiceTypes(invoiceTypesLookup.filter(x => x.clientId == e));
        setPayerList(payerListLookup.filter(x => x.clientId == e))
    }

    const handleCallback = (data: any) => {
        if (data?.canChangeTab) {
            setShowTripLegTab(data.canValidate);
        } else if (data?.isInvalid) {
            openNotificationWithIcon("warning", data.errorMessage, "");
        } else if (data.isCancel) {
            closeModal();
        } else if (data.showMessage) {
            openNotificationWithIcon("success", data.message, "");
            if (currentTab == 'importTripLegTab') {
                if (childRef.current) {
                    childRef.current?.getInvoiceData();
                }
            }
        }
        else if (data.message) {
            openNotificationWithIcon("success", data.message, "");
            search()
        }
    }

    function closeModal() {
        setModal(false);
        setModalData({
            edit: false,
            data: null
        })
        setSelectedInvoice(null)
    }

    useEffect(() => {
        if (!showModal) {
            setModalData({
                edit: false,
                data: null
            })
            handleTabClick('invoiceInfoTab');
        }
    }, [showModal])


    const handleTabClick = (key: string) => {
        setCurrentTab(key);
        if (key === 'invoiceInfoTab') {
            setDrawerConfig({
                title: 'Invoice',
                width: Math.max(drawerScreenWidth, defaultWidth)
            });
        } else if (key === 'importTripLegTab') {
            setDrawerConfig({
                title: `Invoice - Client: ${clientList.find((x) => x.id == client)?.name} :: Invoice #: ${modalData?.data?.invoiceNumber}`,
                width: Math.max(drawerScreenWidth, defaultWidth)
            });
        }
    };

    const drawerTitle = <Tooltip title={drawerConfig.title}>
        <div
            style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
                maxWidth: '800px'
            }}
        >
            {drawerConfig.title}
        </div>
    </Tooltip>


    return <ConfigProvider theme={{
        components: {
            Layout: { bodyBg: "#eff1f5", siderBg: "#fff" }
        }
    }} >
        {contextHolder}
        <Layout style={{
            padding: '20px',
            marginBottom: '5px',
            marginTop: '5px',
        }}>
            <Drawer title={drawerTitle} destroyOnClose={true} maskClosable={false} onClose={closeModal} open={showModal} width={drawerConfig.width} styles={{ body: { background: '#eff1f5' } }}>
                <div>
                    {modalData.edit ?
                        <Tabs type="card" style={{ width: '100%', background: '#fff' }} tabBarStyle={{ marginBottom: '0px' }} activeKey={currentTab} onChange={handleTabClick}>
                            <TabPane tab="Invoice Information" key="invoiceInfoTab">
                                <COBDenialInvoiceDetails ref={childRef} closeModal={closeModal} clientList={clientList} invoiceTypeLookup={invoiceTypesLookup} modal={showModal} modalData={modalData} statusList={statusListLookup} parentCallback={handleCallback} pdrCaseList={pdrCaseList} />
                            </TabPane>
                            {
                                modalData && modalData?.data?.invoiceType == "PDR Cases" && showTripLegTab &&
                                (
                                    <TabPane tab="Import Trip Legs" key="importTripLegTab">
                                        {currentTab == 'importTripLegTab' &&
                                            <CobDenialImportTripLegs clientList={clientList} invoiceInfo={modalData.data} parentCallback={handleCallback} />
                                        }
                                    </TabPane>
                                )
                            }

                        </Tabs>
                        : <CreateCOBDenialInvoice closeModal={closeModal} clientList={clientList} invoiceTypeLookup={invoiceTypesLookup} modal={showModal} userAccess={userAccess} statusList={statusListLookup} parentCallback={handleCallback} pdrCaseList={pdrCaseList} />}
                </div>
            </Drawer>
            <h3 style={{ textTransform: 'uppercase', marginTop: '0px' }}>Cob Denials / Invoices</h3>
            <Flex justify='space-between' style={{ padding: "1rem", alignItems: "center", background: '#fff' }}>
                <label><SearchOutlined />&nbsp;Search</label>
                {userAccess.canAdd && <Button onClick={() => {
                    setModal(true)
                    setModalData({
                        edit: false,
                        data: null
                    })
                }} style={{ marginLeft: '5px' }} type="primary" icon={<PlusOutlined />}>
                    Add Invoice
                </Button>
                }
            </Flex>
            <Skeleton loading={filterLoader} active>
                <Row style={{ padding: '1rem', paddingTop: "0px", background: '#fff' }}>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Client"
                            onChange={(e) => clientSelected(e)}
                            value={client}
                        >
                            {clientList && clientList.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Type"
                            onChange={(e) => setInvoiceType(e)}
                            value={invoiceType}
                            disabled={!client}
                            allowClear
                        >
                            {invoiceTypes && invoiceTypes.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={12}>
                        <RangePicker
                            placeholder={["From Invoice Date", "To Invoice Date"]}
                            style={{ width: '100%' }}
                            format="MM/DD/YYYY"
                            value={[startDate, endDate]}
                            onChange={(dates: any) => {
                                if (dates) {
                                    setStartDate(dates[0]);
                                    setEndDate(dates[1]);
                                } else {
                                    setStartDate('');
                                    setEndDate('');
                                }
                            }}
                        />
                    </Col>
                </Row>
                <Row style={{ padding: '1rem', paddingTop: "0px", background: '#fff' }}>
                    <Col span={6}>
                        <Input value={invoiceNumber ?? ''} placeholder="Invoice #" style={{ width: '90%' }} allowClear onChange={(e) => setInvoiceNumber(e?.target?.value)} />
                    </Col>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Status"
                            onChange={(e) => setStatus(e)}
                            value={status}
                            disabled={!client || !invoiceType}
                            allowClear
                        >
                            {statusList && statusList.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                    <Col span={6}>
                        <Select
                            style={{ width: '90%' }}
                            placeholder="Select a Payer"
                            onChange={(e) => setPayer(e)}
                            value={payer}
                            disabled={!client}
                            allowClear
                        >
                            {payerList && payerList.map(item => (
                                <Option key={item.id}>{item.name}</Option>
                            ))}
                        </Select>
                    </Col>
                </Row>
                <Flex justify='end' style={{ marginBottom: "2rem", padding: "1rem", paddingTop: "0px", background: '#fff' }} gap='small'>
                    <Button onClick={search} loading={loading} style={{ marginLeft: '5px' }} type="primary">
                        Search
                    </Button>
                    <Button onClick={resetFilters} style={{ backgroundColor: '#ffffff', borderColor: '#d9d9d9', marginLeft: '5px', color: 'rgba(0, 0, 0, 0.88)' }} type="primary">
                        Reset
                    </Button>
                </Flex>
            </Skeleton>
            <ColumnDropdown columns={tableColumns} menuVisible={menuVisible} position={position} isChecked={isChecked} setChecked={setChecked} />
            {showTable && <Table style={{ background: "#fff" }}
                scroll={{
                    y: invoiceList?.length > 0 ? tableScrollY : undefined
                }}
                dataSource={invoiceList}
                pagination={{
                    defaultCurrent: 1,
                    current: currentPage,
                    pageSize: pageSize,
                    total: totalPages,
                    showTotal: (total, range) => `${range[0] || 0}-${range[1] || 1} of ${total} items`,
                    showSizeChanger: true,
                }}
                columns={tableColumns}
                onChange={handleTableChange}
                size="small"
                rowKey="invoiceNumber"
                loading={{ indicator: <LoaderSpinner size={24} topMargin="10px" />, spinning: loading }}
                onHeaderRow={(columns, index) => {
                    return {
                        onContextMenu: (event) => {
                            event.preventDefault();
                            if (!menuVisible) {
                                document.addEventListener(`click`, function onClickOutside() {
                                    setMenuVisible(false);
                                    document.removeEventListener(`click`, onClickOutside);
                                });
                            }
                            setMenuVisible(true);
                            setPosition({ x: event.clientX, y: event.clientY });
                        }
                    };
                }}
            />}
        </Layout>
    </ConfigProvider>
}